import React from "react";
import type { RenderSiteProps } from "./RenderSite";

export const TextSection: React.FC<RenderSiteProps> = ({ site }) => {
  const content = site.text?.content?.trim() || "";
  if (!site.text?.is_enabled || !content) {
    return null;
  }

  return (
    <section
      id="text"
      className={`py-12 bg-gradient-to-b from-${site.color}-${site.color_weight} to-${site.color}-${site.color_weight}`}
    >
      <div className="max-w-4xl mx-auto px-6">
        <div
          className={`whitespace-pre-line break-words text-lg leading-relaxed text-${site.textColor} text-justify [text-align-last:center] first-letter:uppercase`}
        >
          {content}
        </div>
      </div>
    </section>
  );
};
